import { __awaiter, __generator } from "tslib";
import { createBindingApi2 } from '../../api/create-binding-v2';
import { paymentForm } from '../payment-form';
export var bindCardV2 = function (apiHost, options) { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, createBindingApi2(apiHost, options)];
            case 1:
                url = _a.sent();
                return [2, paymentForm(apiHost, { url: url })];
        }
    });
}); };
